import { Routes } from '@angular/router';
import { authGuard } from './core/guards/auth.guard';
import { guestGuard } from './core/guards/guest.guard';
import { platformAdminGuard } from './core/guards/platform-admin.guard';
import { unsavedChangesGuard } from './core/guards/unsaved-changes.guard';
import {
  customDomainEntryGuard,
  customDomainWildcardGuard,
} from './core/guards/custom-domain.guard';

export const routes: Routes = [
  // Public routes first (no auth required)
  {
    path: 'f/:publicId',
    loadComponent: () =>
      import('./features/finder/public/public-finder.component').then(
        (m) => m.PublicFinderComponent
      ),
  },
  {
    path: '',
    pathMatch: 'full',
    canActivate: [customDomainEntryGuard],
    loadComponent: () =>
      import('./features/finder/public/public-finder.component').then(
        (m) => m.PublicFinderComponent
      ),
    data: { resolveBy: 'hostname' },
  },
  {
    path: 'login',
    loadComponent: () =>
      import('./features/auth/login/login.component').then((m) => m.LoginComponent),
    canActivate: [guestGuard],
  },
  { path: 'register', redirectTo: 'login', pathMatch: 'full' },
  {
    path: 'accept-invite',
    loadComponent: () =>
      import('./features/auth/accept-invite/accept-invite.component').then(
        (m) => m.AcceptInviteComponent
      ),
  },
  {
    path: 'verify-email',
    loadComponent: () =>
      import('./features/auth/verify-email/verify-email.component').then(
        (m) => m.VerifyEmailComponent
      ),
  },
  {
    path: 'reset-password',
    loadComponent: () =>
      import('./features/auth/reset-password/reset-password.component').then(
        (m) => m.ResetPasswordComponent
      ),
  },
  // Protected routes (require auth)
  {
    path: 'admin',
    loadComponent: () =>
      import('./features/admin/admin.component').then((m) => m.AdminComponent),
    canActivate: [platformAdminGuard],
  },
  {
    path: 'dashboard',
    loadComponent: () => import('./dashboard.component').then((m) => m.DashboardComponent),
    canActivate: [authGuard],
  },
  {
    path: 'finder/:id/build',
    loadComponent: () =>
      import('./features/finder/builder/finder-builder.component').then(
        (m) => m.FinderBuilderComponent
      ),
    canActivate: [authGuard],
    canDeactivate: [unsavedChangesGuard],
  },
  {
    path: 'finder/:id/simple-build',
    loadComponent: () =>
      import('./features/finder/simple-builder/simple-builder.component').then(
        (m) => m.SimpleBuilderComponent
      ),
    canActivate: [authGuard],
  },
  {
    path: 'finder/new',
    loadComponent: () =>
      import('./features/finder/wizard/wizard.component').then(
        (m) => m.FinderWizardComponent
      ),
    canActivate: [authGuard],
  },
  {
    path: 'finder/:id/embed',
    loadComponent: () =>
      import('./features/finder/embed/finder-embed.component').then(
        (m) => m.FinderEmbedComponent
      ),
    canActivate: [authGuard],
  },
  {
    path: 'finder/:id/preview',
    loadComponent: () =>
      import('./features/finder/public/public-finder.component').then(
        (m) => m.PublicFinderComponent
      ),
    canActivate: [authGuard],
    data: { resolveBy: 'finderId', preview: true },
  },
  {
    path: 'finder/:id/products',
    loadComponent: () =>
      import('./features/finder/products/products.component').then(
        (m) => m.ProductsComponent
      ),
    canActivate: [authGuard],
  },
  {
    path: '**',
    canActivate: [customDomainWildcardGuard],
    loadComponent: () =>
      import('./features/finder/public/public-finder.component').then(
        (m) => m.PublicFinderComponent
      ),
    data: { resolveBy: 'hostname' },
  },
];
